import { ref } from 'vue';
import type { GetTaxSchemeListQuery, PenaltySchemeListQuery, SupplierPayRuleListQuery } from '@/graphql/generated';
import { useServices } from '@/core/composables/services';
import { GetTaxSchemeList, PenaltySchemeList, SupplierPayRuleList } from '@/parts/tariffs/gql/tariffs.gql';

const penaltySchemeCollection = ref<PenaltySchemeListQuery['penaltySchemeList']>([]);
const supplierPayRulesCollection = ref<SupplierPayRuleListQuery['supplierPayRuleList']>([]);
const taxSchemesCollection = ref<GetTaxSchemeListQuery['taxSchemeList']>([]);

export const useCollectionsStore = () => {
  const { $api } = useServices();

  const getPenaltySchemeCollection = async () => {
    const result = await $api.query<PenaltySchemeListQuery>(PenaltySchemeList);

    if (result?.data) {
      penaltySchemeCollection.value = result.data.penaltySchemeList;
    }
  };

  const getSupplierPayRulesCollection = async () => {
    const result = await $api.query<SupplierPayRuleListQuery>(SupplierPayRuleList);

    if (result?.data) {
      supplierPayRulesCollection.value = result.data.supplierPayRuleList;
    }
  };

  const getTaxSchemesCollection = async () => {
    const result = await $api.query<GetTaxSchemeListQuery>(GetTaxSchemeList);

    if (result?.data) {
      taxSchemesCollection.value = result.data.taxSchemeList;
    }
  };

  return {
    penaltySchemeCollection,
    getPenaltySchemeCollection,

    supplierPayRulesCollection,
    getSupplierPayRulesCollection,

    taxSchemesCollection,
    getTaxSchemesCollection,
  };
};
